
import {products} from "./feature.products.svelte.js";
import {booking} from "../booking/feature.booking.svelte.js";
import {progress} from "../progress/feature.progress.svelte.js";
import * as booking_scenarios_receipt from "../booking/booking.scenarios.update.receipt.svelte.js";
import * as booking_update from "../booking/booking.scenarios.update.svelte.js";
import * as products_select from "./products.scenarios.select.svelte.js";
import * as products_update from "./products.scenarios.update.svelte.js";
import DateTimeUtil from "../../utils/DateTimeUtil";
import {ENVIRONMENT_DEN_ILP, ENVIRONMENT_DEVARANA, ENVIRONMENT_RIDDERRODE, ENVIRONMENT_SWEETLAKE} from "../../AppConstants";
import AppConfig from "../../AppConfig";
import * as booker_update from "../booker/booker.scenarios.update.svelte.js";
import * as booking_actions from '../booking/actions_booking.svelte.js';
import AppConfigRidderrode from "../../AppConfigRidderrode.js";
import AppConfigDenIlp from "../../AppConfigDenIlp.js";
import AppConfigDevarana from "../../AppConfigDevarana.js";
import AppConfigSweetlake from "../../AppConfigSweetlake.js";

let aAlternateProductPrices = false; // niet veranderen

// Functie: update de prijs van een product op basis van ID
export function scenarioUpdateProductPriceByID(iProductID, iNewPriceCents)
{
  iProductID = parseInt(iProductID);
  const idx = products.lItems.findIndex((oItem) => oItem.iID === iProductID);

  if ( idx !== -1 )
  {
    products.lItems[idx].iPrice = iNewPriceCents;
  }

  booking_actions.handleBookingUpdated('scenarioUpdateProductPriceByID');
}

// Functie: pas prijzen aan op basis van een hardcoded matrix
export function scenarioUpdateProductPriceForTodayWithoutRemoteCheck(iBuyableID)
{
  const sEnvironmentID = progress.sEnvironmentID;
  const sArrivalDate = products.booking?.sArrivalDate; // format 31-03-2019
  const oArrivalDate = DateTimeUtil.getDateFromString(sArrivalDate);
  let bArrivalDateIsWeekend = false;

  if ( oArrivalDate && oArrivalDate.isFriSatSun() === true )
  {
    bArrivalDateIsWeekend = true;
  }

  if ( !aAlternateProductPrices )
  {
    // eenmalig de juiste config laden
    switch ( sEnvironmentID )
    {
      case ENVIRONMENT_RIDDERRODE:
        aAlternateProductPrices = AppConfigRidderrode.aAlternateProductPricesRidderrode;
        break;
      case ENVIRONMENT_DEN_ILP:
        aAlternateProductPrices = AppConfigDenIlp.aAlternateProductPricesDenIlp;
        break;
      case ENVIRONMENT_DEVARANA:
        aAlternateProductPrices = AppConfigDevarana.aAlternateProductPricesDevarana;
        break;
      case ENVIRONMENT_SWEETLAKE:
        aAlternateProductPrices = AppConfigSweetlake.aAlternateProductPricesSweetlake;
        break;
      default:
        aAlternateProductPrices = [];
    }
  }

  for ( const oAlternatePriceConfig of aAlternateProductPrices )
  {
    // checken of de prijs niet eerder veranderd is en nu teruggezet moet worden
    if ( oAlternatePriceConfig.hasOwnProperty("iOriginalPrice") )
    {
      products_update.scenarioUpdateProductPriceByID(oAlternatePriceConfig.iID, oAlternatePriceConfig.iOriginalPrice);
      delete oAlternatePriceConfig.iOriginalPrice;
    }

    for ( const oPriceRule of oAlternatePriceConfig.aRules )
    {
      if (
        oPriceRule.sDate === sArrivalDate ||
        (oPriceRule.sDate === "weekend" && bArrivalDateIsWeekend === true)
      )
      {
        const mProduct = products_select.getProductByID(oAlternatePriceConfig.iID);

        if ( mProduct )
        {
          if ( !oAlternatePriceConfig.hasOwnProperty("iOriginalPrice") )
          {
            oAlternatePriceConfig.iOriginalPrice = mProduct.iPrice;
          }

          products_update.scenarioUpdateProductPriceByID(oAlternatePriceConfig.iID, oPriceRule.iPrice);
        }
      }
    }
  }
}

/**
 * Handle side effects after Phase 2 availability data is received.
 * This function is called from actions_remote after fetchTreatmentsAvailability completes.
 * Keeps the network layer (actions_remote) pure by moving business logic here.
 */
export async function handleAvailabilityUpdateSideEffects()
{
  // 1. Process pending preselected treatment if any
  // This handles the case where a preselected treatment was stored during boot
  // because Phase 2 availability wasn't ready yet
  // NOTE: Preselected treatments are for ALL people in the booking, not just one person
  if ( products.iPendingPreselectedTreatmentID )
  {
    // Guard: if Phase 1 hasn't populated lAvailableTreatments yet, Phase 2 beat it in a race.
    // Don't clear the pending ID — fetchTreatmentsContent will retry once Phase 1 data lands.
    const bPhase1HasData = products.lAvailableTreatments.some(oCategory => oCategory.lItems.length > 0);
    if ( !bPhase1HasData )
    {
      console.log('[DEBUG Preselect] Phase 1 not yet ready, deferring pending treatment:', products.iPendingPreselectedTreatmentID);
    }
    else
    {
      const iPendingID = products.iPendingPreselectedTreatmentID;
      console.log('[DEBUG Preselect] Processing pending treatment:', iPendingID, 'for ALL people');

      // Find the treatment in lAvailableTreatments and check availability
      let bIsAvailable = false;
      products.lAvailableTreatments.forEach(oCategory => {
        oCategory.lItems.forEach(oProduct => {
          if ( oProduct.iID === iPendingID && oProduct.bIsAvailable === true )
          {
            bIsAvailable = true;
          }
        });
      });

      if ( bIsAvailable )
      {
        console.log('[DEBUG Preselect] Pending treatment is available, adding to ALL people in booking');

        // Add to ALL people - this matches the original behavior in addPerson()
        booking.lPeople.forEach(oPerson => {
          booking_update.addProductToPerson(oPerson.sID, iPendingID);
        });

        booking_actions.handleBookingUpdated('handleAvailabilityUpdateSideEffects_preselect');
      }
      else
      {
        console.log('[DEBUG Preselect] Pending treatment is NOT available');
        progress.bThereWasAPreselectedTreatmentButItIsNotAvailable = true;
        progress.bShowMessageThereWasAPreselectedTreatmentButItIsNotAvailable = true;
      }

      // Clear pending state
      products.iPendingPreselectedTreatmentID = false;
    }
  }

  // 1b. Process pending user click treatment if any
  // This handles the case where user clicked "Toevoegen" before Phase 2 availability was ready
  if ( products.oPendingUserClickTreatment )
  {
    const oPending = products.oPendingUserClickTreatment;
    if ( oPending.oProductSet )
    {
      progress.bShowAvailabilityPendingOverlay = false;
      products.oPendingUserClickTreatment = false;
      booking_actions.addShowFirstBookAllProductSetWithAvailabilityCheck(oPending.oProductSet, oPending.sPersonID);
    }
    else
    {
      console.log('[DEBUG UserClick] Processing pending treatment user click:', oPending.iProductID, 'for person:', oPending.sPersonID);

    // Hide the overlay
    progress.bShowAvailabilityPendingOverlay = false;

    // Find the treatment in lAvailableTreatments and check availability
    let bIsAvailable = false;
    products.lAvailableTreatments.forEach(oCategory => {
      oCategory.lItems.forEach(oProduct => {
        if ( oProduct.iID === oPending.iProductID && oProduct.bIsAvailable === true )
        {
          bIsAvailable = true;
        }
      });
    });

    if ( bIsAvailable )
    {
      // console.log('[DEBUG UserClick] Pending treatment is available, adding to booking');
      booking_update.addProductToPerson(
        oPending.sPersonID,
        oPending.iProductID,
        false,
        false,
        {L: "", V: 'x'},
        null,
        oPending.iProductSetID || 0
      );
    }
    else
    {
      // console.log('[DEBUG UserClick] Pending treatment is NOT available');
      // User clicked on something that turned out to be unavailable - the UI will reflect this
    }

    // Clear pending state
      products.oPendingUserClickTreatment = false;
    }
  }

  // 2. Clean up the cart: remove treatments that are no longer available, then
  // re-validate the per-treatment preferred timeslots against the new date/time.
  // Awaited so the caller can keep the loader up until the cart + receipt are reconciled.
  // console.log('[DEBUG Phase2] About to call removeUnavailableTreatmentsBasedOnPhase2Availability()');
  await booking_update.removeUnavailableTreatmentsBasedOnPhase2Availability();
  // console.log('[DEBUG Phase2] removeUnavailableTreatmentsBasedOnPhase2Availability() completed');
}
